import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '../../models/report.model';
import { Column } from '@miq/catalog';
import { getValueFromLOVList, getFormattedValue, extractData } from './data-view-formatter-utils.pipe';
import { EMPTY_STRING } from '@miq/utils';

@Pipe({
  name: 'dataViewFormatter',
  standalone: false,
})
export class DataViewFormatterPipe implements PipeTransform {
  public static extractValue(
    record: any,
    column: Partial<Column> & { rawData?: boolean; filterDuplicates?: boolean; replaceEmptyWith?: any },
    lovValueFormatter?: (lovVal: DataObject) => string
  ): any {
    // return data as is if there is no column
    if (column == null) {
      return record;
    }

    const _valueWhenEmpty = column?.replaceEmptyWith ?? EMPTY_STRING;
    const { rawData = false, filterDuplicates = true } = column;
    let extractedData = extractData(record, column);

    if (extractedData == null || (Array.isArray(extractedData) && extractedData.length === 0)) {
      return _valueWhenEmpty;
    }
    if (column.values?.length > 0) {
      const keyListAsArray = Array.isArray(extractedData) ? extractedData : [extractedData];
      const lovValues = getValueFromLOVList(keyListAsArray, column, filterDuplicates, lovValueFormatter);
      if (lovValues.length > 0) {
        extractedData = lovValues;
      }
    }

    if (extractedData != null) {
      return rawData ? extractedData : getFormattedValue(column, extractedData, filterDuplicates);
    }

    return '';
  }

  public static Transform(
    data: DataObject,
    args: Partial<Column & { settings?: any; mappingLOV?: Array<{ [key: string]: any }> }> = {},
    _updated?: boolean
  ): any {
    const { displayFn, settings = {}, mappingLOV } = args ?? {};
    if (typeof displayFn === 'function') {
      const result = displayFn(data.data, settings, mappingLOV, args);
      return typeof result === 'object' && result?.value != null ? result.value : result;
    }
    return DataViewFormatterPipe.extractValue(data.data, args);
  }

  transform(
    data: DataObject,
    args: Partial<Column & { settings?: any; mappingLOV?: Array<{ [key: string]: any }> }> = {},
    _updated?: boolean
  ): any {
    return DataViewFormatterPipe.Transform(data, args);
  }
}
